import React, { useId } from 'react';

import { MonoInput } from '@src/components/ui';

import FieldShell from './FieldShell';


/**
 * Base mono multi-value field — label above, `MonoInput` chips control, helper/
 * error line below. Receives RHF field props (value/onChange/onBlur/name/ref)
 * plus `error` (bool) and `helperText` from the generic form wrapper.
 *
 * The form value is an ARRAY of identifier strings, which is also the payload
 * shape — no comma join/split at the edges.
 */
const MonoField = React.forwardRef((props, ref) => {
  const {
    label,
    value = [],
    onChange,
    error = false,
    suggested = false,
    helperText = ' ',
    className,
    ...restProps
  } = props;

  const generatedId = useId();
  const id = restProps.id || generatedId;

  return (
    <FieldShell
      id={id}
      label={label}
      className={className}
      suggested={suggested}
      helperText={helperText}
      error={error}
    >
      <MonoInput
        ref={ref}
        id={id}
        invalid={error}
        values={Array.isArray(value) ? value : []}
        onChange={onChange}
        {...restProps}
      />
    </FieldShell>
  );
});

MonoField.displayName = 'MonoField';
export default MonoField;
